import { render, staticRenderFns } from "./Markups.vue?vue&type=template&id=1b6625ce&scoped=true"
import script from "./Markups.vue?vue&type=script&lang=js"
export * from "./Markups.vue?vue&type=script&lang=js"
import style0 from "./Markups.vue?vue&type=style&index=0&id=1b6625ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6625ce",
  null
  
)

export default component.exports